import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../../environments/environment';

function isJwtValid(token: string): boolean {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 > Date.now();
  } catch {
    return false;
  }
}

export const authGuard: CanActivateFn = (route, _state) => {
  const router = inject(Router);
  const rfTknRaw = localStorage.getItem('rf_tkn');
  if (rfTknRaw) {
    try {
      const creds = JSON.parse(rfTknRaw);
      if (isJwtValid(creds)) {
        // Redirect to process-login
        const redirectUrl = `/process-token?redirect-url=${route.queryParams['redirect-url'] ?? ''}`;

        void router.navigateByUrl(redirectUrl);
        return false;
      }
    } catch {
      localStorage.removeItem(environment.refreshToken);
      return true;
    }
  }
  localStorage.removeItem(environment.refreshToken);
  return true;
};
